import { useState } from "react";
import styled from "styled-components";

const Li = styled.li`
  border: 2px solid black;
  box-sizing: border-box;
  width: 30%;
  min-width: 150px;
  padding: 20px 0 40px;
  margin-bottom: 10px;
  list-style: none;
  text-align: center;
  position: relative;

  &:not(:nth-child(3n)) {
    margin-right: 5%;
  }

  button {
    position: absolute;
    bottom: 0;
    padding: 3px 6px;
  }

  button:nth-of-type(1) {
    right: 10px;
  }

  button:nth-of-type(2) {
    right: 60px;
  }
`;

function ItemList({ item, onDelete, onChange }) {
  const [change, setChange] = useState(false);
  const [changeText, setChangeText] = useState(item.value);

  const deleteId = () => {
    onDelete(item.id);
  };

  const changeStart = () => {
    onChange(item.id, changeText);
    setChange(change ? false : true);
  };

  const valueChange = (e) => {
    const nextValue = e.target.value;
    setChangeText(nextValue);
  };

  const handleCancel = () => {
    setChangeText(item.value);
    setChange(false);
  };

  const onKeyPress = (e) => {
    if (e.key === "Enter") {
      changeStart();
    }
  };

  return (
    <Li>
      {change || <button onClick={deleteId}>삭제</button>}
      {change && <button onClick={handleCancel}>취소</button>}
      <button onClick={changeStart}>수정</button>
      {change || changeText}
      {change && (
        <input
          id="title"
          type="text"
          value={changeText}
          onChange={valueChange}
          onKeyPress={onKeyPress}
          autoFocus
        />
      )}
    </Li>
  );
}

function ItemsList({ items, onDelete, onChange }) {
  return (
    <ul>
      {items.map((item) => {
        return (
          <ItemList
            key={item.id}
            item={item}
            onDelete={onDelete}
            onChange={onChange}
          />
        );
      })}
    </ul>
  );
}

export default ItemsList;
